import * as packageJsonData from "../../../../package.json";

const packageJson = packageJsonData;

export const CONFIG: any = {
  VERSION: packageJson.version,
  COMMIT_INFO: packageJson.commitInfo,
  EMAIL_PATTERN:
    "[A-Za-z0-9!#$%&'*+-/=?^_`.{|}~]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}",
};
